import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap'; // Type defintitions

import * as TYPES from '../../types'; // Constants

import * as CONSTANTS from '../../constants'; // JSS

import { Image, Link, RichText } from '@sitecore-jss/sitecore-jss-react'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker'; // Design System

import Heading from '../heading/Heading';
import VideoImage from '../videoimage/VideoImage';
import Wrapper from '../wrapper/Wrapper';
import { connect } from 'react-redux';
import ducks from '../../ducks';
import { useFlags } from 'launchdarkly-react-client-sdk';

var MegaBanner = function MegaBanner(props) {
  var _model$title3, _model$subtitle, _props$personalize2, _modelState$bannerSti, _modelState$bannerSti2, _modelState$videoUrl, _modelState$videoUrl$, _modelState$link1$val, _modelState$link2$val;

  var model = props.model,
      type = props.type,
      align = props.align,
      layout = props.layout,
      _props$isEditing = props.isEditing,
      isEditing = _props$isEditing === void 0 ? false : _props$isEditing,
      htmlId = props.htmlId,
      position = props.position;
  var classType = 'cb-banner';
  classType += typeof type !== 'undefined' && type !== 'default' ? " cb-banner--side cb-banner--".concat(type) : '';
  classType += typeof align !== 'undefined' ? " cb-banner--side-".concat(align) : '';
  var container = typeof type !== 'undefined' ? "cb-banner__container" : '';

  var bannerClick = function bannerClick() {
    var _model$value, _model$value$title, _model$title, _model$value2, _model$value2$title, _model$title2;

    var data = {
      gtm: {
        uniqueEventId: '47',
        elementTarget: (model === null || model === void 0 ? void 0 : (_model$value = model.value) === null || _model$value === void 0 ? void 0 : (_model$value$title = _model$value.title) === null || _model$value$title === void 0 ? void 0 : _model$value$title.value) || (model === null || model === void 0 ? void 0 : (_model$title = model.title) === null || _model$title === void 0 ? void 0 : _model$title.value) || (model === null || model === void 0 ? void 0 : model.value),
        elementText: (model === null || model === void 0 ? void 0 : (_model$value2 = model.value) === null || _model$value2 === void 0 ? void 0 : (_model$value2$title = _model$value2.title) === null || _model$value2$title === void 0 ? void 0 : _model$value2$title.value) || (model === null || model === void 0 ? void 0 : (_model$title2 = model.title) === null || _model$title2 === void 0 ? void 0 : _model$title2.value) || (model === null || model === void 0 ? void 0 : model.value),
        elementId: htmlId
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var gtmData = {
    "data-gaattrbannertitle": model === null || model === void 0 ? void 0 : (_model$title3 = model.title) === null || _model$title3 === void 0 ? void 0 : _model$title3.value,
    "data-gaattrbannersubtitle": model === null || model === void 0 ? void 0 : (_model$subtitle = model.subtitle) === null || _model$subtitle === void 0 ? void 0 : _model$subtitle.value,
    "data-gaattrbannerposition": htmlId
  };
  var flags = useFlags();
  var releasePersonalizationBannerSlide = flags['releasePersonalizationBannerSlide'] ? flags['releasePersonalizationBannerSlide'] : false;

  var _useState = useState(model || null),
      _useState2 = _slicedToArray(_useState, 2),
      modelState = _useState2[0],
      setModelState = _useState2[1];

  var _useState3 = useState(typeof window.engage !== 'undefined' ? true : false),
      _useState4 = _slicedToArray(_useState3, 2),
      engageAvailable = _useState4[0],
      setEngageAvailable = _useState4[1];

  useEffect(function () {
    if (!releasePersonalizationBannerSlide) {
      return;
    } // Set a timer to periodically check for window.engage availability


    var checkEngageAvailability = setInterval(function () {
      if (window.engage) {
        setEngageAvailable(true);
        clearInterval(checkEngageAvailability);
      }
    }, 1000); // Cleanup function to clear the timer when the component unmounts

    return function () {
      clearInterval(checkEngageAvailability);
    };
  }, [releasePersonalizationBannerSlide]);
  useEffect(function () {
    if (!releasePersonalizationBannerSlide) {
      setModelState(model);
      return;
    }

    if (engageAvailable) {
      var _model$personalizatio, _model$personalizatio2, _model$personalizatio3;

      // window.engage is available, verify if the component has personalizationScenario info
      if (model === null || model === void 0 ? void 0 : (_model$personalizatio = model.personalizationScenario) === null || _model$personalizatio === void 0 ? void 0 : (_model$personalizatio2 = _model$personalizatio.fields) === null || _model$personalizatio2 === void 0 ? void 0 : (_model$personalizatio3 = _model$personalizatio2.FriendlyID) === null || _model$personalizatio3 === void 0 ? void 0 : _model$personalizatio3.value) {
        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _props$personalize, _personalizeFields$pr, _personalizeFields$pr2, _model$image, _personalizeFields$pr3, _personalizeFields$pr4, _personalizeFields$pr5, _personalizeFields$pr6, _personalizeFields$pr7, _personalizeFields$pr8, _personalizeFields$pr9, _personalizeFields$pr10, _personalizeFields$pr11, _personalizeFields$pr12, _personalizeFields$pr13, _model$link;

          var personalizeFields;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return props.getPersonalizeInfo(model.id, model.personalizationScenario.fields.FriendlyID.value, (_props$personalize = props.personalize) === null || _props$personalize === void 0 ? void 0 : _props$personalize.pageViewData);

                case 2:
                  personalizeFields = _context.sent;
                  setModelState(_objectSpread(_objectSpread({}, model), {}, {
                    image: {
                      value: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr = personalizeFields.promoData) === null || _personalizeFields$pr === void 0 ? void 0 : (_personalizeFields$pr2 = _personalizeFields$pr.PromoImage) === null || _personalizeFields$pr2 === void 0 ? void 0 : _personalizeFields$pr2.value) || (model === null || model === void 0 ? void 0 : (_model$image = model.image) === null || _model$image === void 0 ? void 0 : _model$image.value)
                    },
                    title: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr3 = personalizeFields.promoData) === null || _personalizeFields$pr3 === void 0 ? void 0 : (_personalizeFields$pr4 = _personalizeFields$pr3.Header) === null || _personalizeFields$pr4 === void 0 ? void 0 : _personalizeFields$pr4.value) ? personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr5 = personalizeFields.promoData) === null || _personalizeFields$pr5 === void 0 ? void 0 : _personalizeFields$pr5.Header : model.title,
                    subtitle: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr6 = personalizeFields.promoData) === null || _personalizeFields$pr6 === void 0 ? void 0 : (_personalizeFields$pr7 = _personalizeFields$pr6.SubHeading) === null || _personalizeFields$pr7 === void 0 ? void 0 : _personalizeFields$pr7.value) ? personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr8 = personalizeFields.promoData) === null || _personalizeFields$pr8 === void 0 ? void 0 : _personalizeFields$pr8.SubHeading : model.subtitle,
                    text: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr9 = personalizeFields.promoData) === null || _personalizeFields$pr9 === void 0 ? void 0 : (_personalizeFields$pr10 = _personalizeFields$pr9.Copy) === null || _personalizeFields$pr10 === void 0 ? void 0 : _personalizeFields$pr10.value) ? personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr11 = personalizeFields.promoData) === null || _personalizeFields$pr11 === void 0 ? void 0 : _personalizeFields$pr11.Copy : model.text,
                    link1: {
                      value: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr12 = personalizeFields.promoData) === null || _personalizeFields$pr12 === void 0 ? void 0 : (_personalizeFields$pr13 = _personalizeFields$pr12.Link) === null || _personalizeFields$pr13 === void 0 ? void 0 : _personalizeFields$pr13.value) || (model === null || model === void 0 ? void 0 : (_model$link = model.link1) === null || _model$link === void 0 ? void 0 : _model$link.value)
                    }
                  }));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    }
  }, [engageAvailable, (_props$personalize2 = props.personalize) === null || _props$personalize2 === void 0 ? void 0 : _props$personalize2.pageViewData, releasePersonalizationBannerSlide]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    className: classType
  }, /*#__PURE__*/React.createElement("div", {
    className: container,
    id: htmlId,
    onClick: bannerClick
  }, ((modelState === null || modelState === void 0 ? void 0 : modelState.image) || (modelState === null || modelState === void 0 ? void 0 : modelState.videoUrl)) && /*#__PURE__*/React.createElement(ImageVideoContainer, {
    image: modelState === null || modelState === void 0 ? void 0 : modelState.image,
    video: modelState === null || modelState === void 0 ? void 0 : modelState.videoUrl,
    autoplay: modelState.autoplay,
    displayControls: modelState.displayControls,
    playsound: modelState.playsound,
    isEditing: isEditing
  }), (modelState === null || modelState === void 0 ? void 0 : (_modelState$bannerSti = modelState.bannerStickerImage) === null || _modelState$bannerSti === void 0 ? void 0 : (_modelState$bannerSti2 = _modelState$bannerSti.value) === null || _modelState$bannerSti2 === void 0 ? void 0 : _modelState$bannerSti2.src) && (modelState === null || modelState === void 0 ? void 0 : (_modelState$videoUrl = modelState.videoUrl) === null || _modelState$videoUrl === void 0 ? void 0 : (_modelState$videoUrl$ = _modelState$videoUrl.value) === null || _modelState$videoUrl$ === void 0 ? void 0 : _modelState$videoUrl$.href) === '' && /*#__PURE__*/React.createElement(BannerStickerContainer, {
    bannerStickerImage: modelState === null || modelState === void 0 ? void 0 : modelState.bannerStickerImage
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__copy-container"
  }, (modelState === null || modelState === void 0 ? void 0 : modelState.subtitle) && /*#__PURE__*/React.createElement(BannerCopyComponent, {
    field: modelState.subtitle,
    gtmData: gtmData,
    level: "2",
    className: "cb-banner__subtitle"
  }), (modelState === null || modelState === void 0 ? void 0 : modelState.title) && /*#__PURE__*/React.createElement(BannerCopyComponent, {
    field: modelState.title,
    level: "2",
    className: "cb-banner__title"
  }), typeof (modelState === null || modelState === void 0 ? void 0 : modelState.text) !== "undefined" && /*#__PURE__*/React.createElement(BannerCopyRichText, {
    text: modelState.text
  }), typeof (modelState === null || modelState === void 0 ? void 0 : modelState.link1) !== "undefined" || (modelState === null || modelState === void 0 ? void 0 : modelState.link2) !== "undefined" ? /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__cta"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: "row-grid"
  }, Boolean((_modelState$link1$val = modelState.link1.value) === null || _modelState$link1$val === void 0 ? void 0 : _modelState$link1$val.href) ? /*#__PURE__*/React.createElement(CtaItem, {
    link: modelState.link1,
    id: "".concat(htmlId, "-1"),
    gtmData: gtmData,
    type: "primary"
  }) : "", Boolean((_modelState$link2$val = modelState.link2.value) === null || _modelState$link2$val === void 0 ? void 0 : _modelState$link2$val.href) ? /*#__PURE__*/React.createElement(CtaItem, {
    link: modelState.link2,
    id: "".concat(htmlId, "-2"),
    gtmData: gtmData,
    type: "secondary"
  }) : ""))) : "")));
};

var ImageVideoContainer = function ImageVideoContainer(_ref2) {
  var _video$value;

  var image = _ref2.image,
      video = _ref2.video,
      autoplay = _ref2.autoplay,
      displayControls = _ref2.displayControls,
      playsound = _ref2.playsound,
      isEditing = _ref2.isEditing;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__image-container ".concat((video === null || video === void 0 ? void 0 : (_video$value = video.value) === null || _video$value === void 0 ? void 0 : _video$value.href) && "cb-banner__video-container")
  }, /*#__PURE__*/React.createElement(VideoImage, {
    image: image,
    video: video,
    autoplay: autoplay,
    displayControls: displayControls,
    playsound: playsound,
    isEditing: isEditing
  }));
};

var BannerStickerContainer = function BannerStickerContainer(_ref3) {
  var bannerStickerImage = _ref3.bannerStickerImage;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__image-bg"
  }, /*#__PURE__*/React.createElement(Image, {
    media: bannerStickerImage
  }));
};

var BannerCopyComponent = function BannerCopyComponent(_ref4) {
  var field = _ref4.field,
      level = _ref4.level,
      className = _ref4.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__copy"
  }, /*#__PURE__*/React.createElement(Heading, {
    field: field,
    level: level,
    className: className
  }));
};

var BannerCopyRichText = function BannerCopyRichText(_ref5) {
  var text = _ref5.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__copy cb-l-margin-medium--bottom"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: text,
    tag: "p",
    className: "cb-banner__text"
  }));
};

var CtaItem = function CtaItem(props, type) {
  var _props$link = props.link,
      link = _props$link === void 0 ? {} : _props$link,
      id = props.id,
      _props$gtmData = props.gtmData,
      gtmData = _props$gtmData === void 0 ? {} : _props$gtmData; // console.log(id, gtmData, "VALUES")

  var buttonClass = type === 'secondary' ? CONSTANTS.BANNER_SECONDARY_BUTTON : CONSTANTS.BANNER_PRIMARY_BUTTON;

  var ctaClick = function ctaClick(e) {
    var _link$value, _link$value2;

    var data = {
      gtm: {
        uniqueEventId: '48',
        elementText: (_link$value = link.value) === null || _link$value === void 0 ? void 0 : _link$value.text,
        elementLink: (_link$value2 = link.value) === null || _link$value2 === void 0 ? void 0 : _link$value2.href,
        elementId: id
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  return /*#__PURE__*/React.createElement(Col, {
    className: "cb-banner__cta-item"
  }, /*#__PURE__*/React.createElement(Link, _extends({
    field: link,
    showLinkTextWithChildrenPresent: "true",
    onClick: ctaClick,
    id: id
  }, gtmData, {
    className: typeof link.value.class !== "undefined" && link.value.class !== "" ? link.value.class : buttonClass
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    personalize: state.personalize
  };
};

var personalizeOperations = ducks.personalize.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPersonalizeInfo: function getPersonalizeInfo(id, friendlyId, pageViewData) {
      return dispatch(personalizeOperations.handleGetPersonalizeInfo(id, friendlyId, pageViewData));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MegaBanner);